import * as React from "react";
import type { SVGProps } from "react";

const SvgChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={31}
    viewBox="0 0 33 31"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.681 11.102a3.675 3.675 0 0 0-3.668 3.674v6.5a3.675 3.675 0 0 0 3.668 3.673h7.933a.78.78 0 0 1 .495.178l3.513 2.89V25.72c0-.21.084-.41.233-.557a.74.74 0 0 1 .56-.224l.714.011a2.764 2.764 0 0 0 2.754-2.764v-7.41a3.675 3.675 0 0 0-3.668-3.673zm12.721 19.349a.77.77 0 0 1-.495-.178l-4.573-3.762h-7.653a5.24 5.24 0 0 1-5.228-5.236v-6.5a5.24 5.24 0 0 1 5.228-5.235h12.534a5.24 5.24 0 0 1 5.228 5.236v7.409a4.33 4.33 0 0 1-4.261 4.326v3.159a.783.783 0 0 1-.78.781M4.998 20.91a.784.784 0 0 1-.78-.781v-3.16C1.88 16.93 0 15.006 0 12.646v-7.41C0 2.35 2.325 0 5.183 0h12.395c2.858 0 5.182 2.35 5.182 5.236v2.306a.78.78 0 0 1-1.56.001V5.235c0-2.026-1.625-3.674-3.622-3.674H5.183c-1.998 0-3.623 1.648-3.623 3.674v7.41c0 1.523 1.222 2.763 2.724 2.763l.702-.011a.783.783 0 0 1 .792.781v2.288l.829-.69a.782.782 0 0 1 .996 1.203l-2.107 1.75a.77.77 0 0 1-.498.18m11.751-2.169h-2.723a.781.781 0 0 1 0-1.562h2.723a.781.781 0 0 1 0 1.562m5.567 0h-2.723a.781.781 0 0 1 0-1.562h2.723a.781.781 0 0 1 0 1.562m5.566 0h-2.723a.781.781 0 0 1 0-1.562h2.723a.781.781 0 0 1 0 1.562"
    />
  </svg>
);
export default SvgChat;
